<template>
<section>
  <v-parallax v-bind:src="require('../../assets/pictures/Keller6.jpeg')"
  height="600">
    <v-layout column align-center justify-center>
      <h1 class="mb-2 display-2 text-xs-center">Teutonenkeller</h1>


      <v-btn
        class="blue lighten-2 mt-5"
        dark
        large
        @click="xyz = !xyz"
      >
        Weitere Fotos
      </v-btn>
      <v-dialog
        v-model="xyz"
        lazy
        width="100%"
      >
        <v-card>
          <KellerGallery/>
        </v-card>


      </v-dialog>
    </v-layout>
  </v-parallax>
</section>
</template>

<script>
import KellerGallery from './KellerGallery.vue';

export default {
  components: {
    KellerGallery,
  },
  data: () => ({
    xyz: false,
  }),
};
</script>
